/* ═══════════════════════════════════════════════════
   NEWJAISA — PRICING PAGE
   File: assets/component-pricing.js
   Namespaced under PricingPage · No global conflicts
   Uses DOMContentLoaded · No external dependencies
═══════════════════════════════════════════════════ */

'use strict';

var PricingPage = (function () {

  /* ── PRIVATE HELPERS ──────────────────────────── */
  function $(id) { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── TAB SWITCHER ─────────────────────────────── */
  function switchTab(name) {
    $$('.prc-tab-panel').forEach(function (p) { p.classList.remove('active'); });
    $$('.prc-tab-btn').forEach(function (b)   { b.classList.remove('active'); });

    var panel = $('prc-tab-' + name);
    if (panel) panel.classList.add('active');

    var btn = document.querySelector('[data-tab="' + name + '"]');
    if (btn) {
      btn.classList.add('active');
      /* Scroll tab button into view on mobile */
      if (btn.scrollIntoView) {
        btn.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      }
    }

    /* Re-trigger reveal for newly visible panel */
    observeReveals();
  }

  /* ── SCROLL REVEAL ────────────────────────────── */
  function observeReveals() {
    if (!('IntersectionObserver' in window)) {
      $$('.prc-reveal').forEach(function (el) { el.classList.add('prc-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var parent = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('prc-reveal') && !el.classList.contains('prc-visible');
            })
          : [];
        var idx = siblings.indexOf(entry.target);

        setTimeout(function () {
          entry.target.classList.add('prc-visible');
        }, Math.max(0, idx * 75));

        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.prc-reveal:not(.prc-visible)').forEach(function (el) { io.observe(el); });
  }

  /* ── FORM VALIDATION ──────────────────────────── */
  function validate() {
    var ok = true;

    function chk(groupId, inputId, testFn) {
      var group = $(groupId);
      var input = $(inputId);
      if (!group || !input) return;
      var pass = testFn(input.value);
      group.classList.toggle('prc-has-err', !pass);
      input.classList.toggle('prc-err', !pass);
      if (!pass && ok) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        input.focus();
      }
      if (!pass) ok = false;
    }

    chk('prc-fg-company', 'prc-f-company', function (v) { return v.trim().length > 1; });
    chk('prc-fg-name',    'prc-f-name',    function (v) { return v.trim().length > 1; });
    chk('prc-fg-phone',   'prc-f-phone',   function (v) { return v.replace(/\D/g, '').length >= 10; });
    chk('prc-fg-devices', 'prc-f-devices', function (v) { return v.trim().length > 0; });

    return ok;
  }

  function clearErr(inputEl, groupId) {
    inputEl.classList.remove('prc-err');
    var g = $(groupId);
    if (g) g.classList.remove('prc-has-err');
  }

  /* ── FORM SUBMIT ──────────────────────────────── */
  function submitQuote() {
    if (!validate()) return;

    var btn = $('prc-quote-submit');
    if (btn) btn.classList.add('prc-loading');

    setTimeout(function () {
      var email   = $('prc-f-email');
      var ref     = 'NJ-' + Date.now().toString(36).toUpperCase().slice(-6);
      var emailEl = $('prc-s-email');
      var refEl   = $('prc-s-ref');

      if (emailEl) emailEl.textContent = (email && email.value) ? email.value : 'your inbox';
      if (refEl)   refEl.textContent   = ref;

      var formArea = $('prc-form-area');
      var success  = $('prc-success-box');
      if (formArea) formArea.style.display = 'none';
      if (success)  success.style.display  = 'flex';
      if (btn)      btn.classList.remove('prc-loading');
    }, 1600);
  }

  function resetForm() {
    var formArea = $('prc-form-area');
    var success  = $('prc-success-box');
    if (formArea) formArea.style.display = 'block';
    if (success)  success.style.display  = 'none';

    ['prc-f-company', 'prc-f-name', 'prc-f-phone', 'prc-f-email',
     'prc-f-devices', 'prc-f-notes', 'prc-f-model'].forEach(function (id) {
      var el = $(id);
      if (el) el.value = '';
    });

    $$('.prc-has-err').forEach(function (g) { g.classList.remove('prc-has-err'); });
    $$('.prc-err').forEach(function (i) { i.classList.remove('prc-err'); });
  }

  /* ── BUILD CONTACT LINKS ──────────────────────── */
  function val(id) { var el = $(id); return el ? el.value : ''; }

  function buildWALink() {
    var msg = 'Hi NewJaisa Team,\n\nI would like to request a pricing quote.\n\n'
      + (val('prc-f-name')    ? '*Name:* '             + val('prc-f-name')    + '\n' : '')
      + (val('prc-f-company') ? '*Company:* '          + val('prc-f-company') + '\n' : '')
      + (val('prc-f-phone')   ? '*Phone:* '            + val('prc-f-phone')   + '\n' : '')
      + (val('prc-f-devices') ? '*Devices needed:* '   + val('prc-f-devices') + '\n' : '')
      + (val('prc-f-model')   ? '*Model:* '            + val('prc-f-model')   + '\n' : '')
      + (val('prc-f-notes')   ? '*Notes:* '            + val('prc-f-notes')   + '\n' : '')
      + '\nPlease send me a custom quote. Thank you!';
    return 'https://wa.me/919535698866?text=' + encodeURIComponent(msg);
  }

  function buildEmailLink() {
    var subject = 'Pricing Quote Request' + (val('prc-f-company') ? ' — ' + val('prc-f-company') : '');
    var body = 'Hi NewJaisa Team,\n\nI would like a pricing quote.\n\n'
      + 'Name: '               + val('prc-f-name')    + '\n'
      + 'Company: '            + val('prc-f-company') + '\n'
      + 'Phone: '              + val('prc-f-phone')   + '\n'
      + 'Devices needed: '     + val('prc-f-devices') + '\n'
      + 'Procurement model: '  + val('prc-f-model')   + '\n'
      + 'Notes: '              + val('prc-f-notes')   + '\n\nThank you!';
    return 'mailto:business@newjaisa.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  function updateContactLinks() {
    var waBtn    = $('prc-wa-btn');
    var emailBtn = $('prc-email-btn');
    if (waBtn)    waBtn.href    = buildWALink();
    if (emailBtn) emailBtn.href = buildEmailLink();
  }

  /* ── EVENT BINDING ────────────────────────────── */
  function bindEvents() {
    /* Tab buttons */
    $$('.prc-tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-tab');
        if (tab) switchTab(tab);
      });
    });

    /* Footer tab links */
    $$('[data-tab-link]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var tab = link.getAttribute('data-tab-link');
        if (tab) {
          switchTab(tab);
          var nav = $('prc-tab-nav');
          if (nav) nav.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    /* Submit button */
    var submitBtn = $('prc-quote-submit');
    if (submitBtn) submitBtn.addEventListener('click', submitQuote);

    /* Reset button */
    var resetBtn = $('prc-btn-reset');
    if (resetBtn) resetBtn.addEventListener('click', resetForm);

    /* Live contact link updates */
    ['prc-f-company', 'prc-f-name', 'prc-f-phone', 'prc-f-email',
     'prc-f-devices', 'prc-f-model', 'prc-f-notes'].forEach(function (id) {
      var el = $(id);
      if (el) el.addEventListener('input', updateContactLinks);
    });

    /* Clear validation errors on input */
    var fieldMap = {
      'prc-f-company': 'prc-fg-company',
      'prc-f-name':    'prc-fg-name',
      'prc-f-phone':   'prc-fg-phone',
      'prc-f-devices': 'prc-fg-devices'
    };
    Object.keys(fieldMap).forEach(function (inputId) {
      var el = $(inputId);
      if (el) {
        el.addEventListener('input', function () {
          clearErr(el, fieldMap[inputId]);
          updateContactLinks();
        });
      }
    });
  }

  /* ── INIT ─────────────────────────────────────── */
function init() {
  bindEvents();
  observeReveals();

  const hash = window.location.hash;

  const tabMap = {
    '#prc-tab-included': 'included',
    '#prc-tab-warranty': 'warranty',
    '#prc-tab-shipping': 'shipping',
    '#prc-tab-privacy': 'privacy'
  };

  if (tabMap[hash]) {

    switchTab(tabMap[hash]);

    setTimeout(function () {
      const target = document.querySelector(hash);

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 300);

  }
}

  /* ── PUBLIC API ───────────────────────────────── */
  return {
    init:       init,
    switchTab:  switchTab
  };

})();

document.addEventListener('DOMContentLoaded', function () {
  PricingPage.init();
});

//1st April 2026 Privacy Dropdown funcation 
document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("prc-policy-toggle");
  const dropdown = toggle?.closest(".prc-dropdown");

  if (toggle && dropdown) {
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      dropdown.classList.toggle("active");
    });

    // Close when clicking outside
    document.addEventListener("click", function () {
      dropdown.classList.remove("active");
    });
  }
});
